export const PRICE_PLAN_BUTTON_LABELS = {
  GET_STARTED: "Get started",
  GET_PLAN: "Get plan",
  MANAGE: "Manage",
  RENEW: "Renew",
  UPGRADE: "Upgrade",
  GO_MONTHLY: "Go monthly",
  GO_YEARLY: "Go yearly",
  DOWNGRADE: "Downgrade",
} as const;
